import { useQuery } from '@tanstack/react-query';
import { APIIntegrationImPACT } from 'lib/api/firebase/apis/api-integration-impact';
import { queryKeyFactory } from 'lib/utils/queryKeyFactory';

export function useToOnboardingQuery(args: {
  impactOrganisationId?: string;
  domain?: string;
  locationCode: string;
  passportID: string;
}) {
  return useQuery({
    queryKey: queryKeyFactory.integration.impact.toOnboarding(
      args.impactOrganisationId ?? '',
      args.domain ?? '',
      args.locationCode,
      args.passportID
    ),
    queryFn: () => APIIntegrationImPACT.toOnboarding({
      ...(args.impactOrganisationId && {
        impactOrganisationID: args.impactOrganisationId
      }),
      ...(args.domain && { domain: args.domain }),
      location: args.locationCode,
      passportID: args.passportID
    }),
    enabled: !!args.impactOrganisationId || !!args.domain
  });
}
